export default __webpack_public_path__ + "static/media/cardDeck.526ad2d5.png";